import { BaseTable } from "./BaseTable";

export function VideosFinishedTable() {
	return <BaseTable preset="finished" />;
}
